export { WalletAwardTile } from './WalletAwardTile';
export type {
  WalletAwardTileProps,
  WalletAwardTileStatusVariant,
  WalletAwardTileMediaVariant,
} from './WalletAwardTile.types';
